import { render, staticRenderFns } from "./voteAdmin.vue?vue&type=template&id=56e79390&"
import script from "./voteAdmin.vue?vue&type=script&lang=js&"
export * from "./voteAdmin.vue?vue&type=script&lang=js&"
import style0 from "./voteAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports